import React, { ReactElement, ReactNode } from 'react';
import { SearchTab } from './SearchTab';
import { TabsList } from './styled';

interface TabData {
  name: string;
  label: string;
  itemsCount?: number;
  stat?: string;
}

interface SearchTabsProps {
  currentTabId: number;
  switchTab: React.Dispatch<React.SetStateAction<number>>;
  children?: ReactNode;
  titles?: TabData[];
  disabled: boolean;
}

export const SearchTabs = ({
  children,
  switchTab,
  currentTabId,
  titles,
  disabled
}: SearchTabsProps) => {
  const tabTitles = titles || React.Children.toArray(children);

  return (
    <TabsList>
      {tabTitles?.map((tab, i) => {
        const tabData = (tab as ReactElement).props || tab;

        return (
          <SearchTab
            key={i}
            name={tabData.name}
            text={tabData.label}
            currentTabId={currentTabId}
            switchTab={switchTab}
            tabId={i}
            itemsCount={tabData.itemsCount}
            disabled={disabled}
            stat={tabData.stat}
          />
        );
      })}
    </TabsList>
  );
};
